// Class: haxe.io.Eof

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var Eof = function() {
}

// Meta

Eof.__name__ = "haxe.io.Eof";
Eof.__isInterface__ = false;
Eof.prototype = {
	toString: function() {
		return "Eof";
	}
};
Eof.prototype.__class__ = Eof.prototype.constructor = $hxClasses["haxe.io.Eof"] = Eof;

// Init



// Statics




// Export

exports.default = Eof;